import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { DriverApiCipia, DriverProgrammingList } from '../models/interfaces';
import { CustomToastMessagessService } from 'src/app/map/services/custom-toast-messagess.service';
import { DriversService } from './drivers.service';
import { DriverListIcipia, DriverProgramming } from '../models/interfaces';
import { map, timeout } from 'rxjs/operators';
import { PermissionService } from 'src/app/permiss/permission.service';
export interface VehicleEnrolledConfig {
  limit : number,
  onlyOneEnrolled : boolean
}

export interface EnrollmentRequestHistory {
  [imei: string]: {
    [driverID: string]: DriverApiCipia
  }
}
@Injectable({
  providedIn: 'root'
})
export class DriverEnrollmentService {


  public enrollmentAccess : boolean = false;

  private specialVehicle : {[type : string] : VehicleEnrolledConfig} = {
    "ALL" : {
      limit :20,
      onlyOneEnrolled : false
    }
  }

  public hasEnrolledPermission = true;
  public hasUnrolledPermission = true;

  public enrollmentRequestHistory: BehaviorSubject<EnrollmentRequestHistory>

  constructor(
    private driverService: DriversService,
    private customTost: CustomToastMessagessService,
    private permissionService : PermissionService
  ) {
    this.enrollmentRequestHistory = new BehaviorSubject<EnrollmentRequestHistory>({})
    this.hasEnrollmentPermission()
  }


  private async hasEnrollmentPermission (){
    const hasAccess = await this.permissionService.hasPermission('drivers_enrollment_cipia_actions');
    console.log("enrolled access driver", hasAccess)
    
    if (hasAccess) {
      this.enrollmentAccess = true
    } else {
      this.enrollmentAccess = false
    }
  }
  
  public getEnrollmentRequestHistory(): Observable<EnrollmentRequestHistory> {
    return this.enrollmentRequestHistory.asObservable();
  }


  public getDriverEnrolledFromVehicle(imei: string): Observable<DriverListIcipia[]> {
    return this.driverService.getDriversEnrolledList(imei).pipe(
      timeout(20000), // Tiempo límite de 20 segundos
      map((response) => JSON.parse(response.data.code))
    );
  }

  public tranformCipiaListToDrivers(driversEnrolledConfirm: DriverListIcipia[]): DriverProgramming[] {
    const driversEnrolled: DriverProgramming[] = this.driverService.driversProgramming
      .filter(driver =>
        driver.key_type === 'ICIPIA' &&
        driver.fecha_fin == null &&
        driversEnrolledConfirm.some(enrolled =>
          enrolled.driverId === driver.key_number && enrolled.permission === true
        )
      )
      .map(driver => ({ ...driver, status: 'success', type: "enrolar", savedConfirm: true }));
    return driversEnrolled;
  }

  public getDriverEnrolledHistoryList(
    driversEnrolledConfirm: DriverListIcipia[],
    imei: string
  ): DriverProgramming[] {
    const allHistory = this.enrollmentRequestHistory.getValue();

    // Ahora `history` es un objeto { [driverID]: DriverApiCipia }
    const history = allHistory[imei] ?? {};

    // 1. Convertir confirmados por servidor a historial (status: 'success')
    const driversEnrolled: DriverProgramming[] = this.driverService.driversProgramming
      .filter(driver =>
        driver.key_type === 'ICIPIA' &&
        driver.fecha_fin == null &&
        driversEnrolledConfirm.some(enrolled =>
          enrolled.driverId === driver.key_number && enrolled.permission === true
        )
      )
      .map(driver => ({ ...driver, status: 'success', type: 'enrolar', savedConfirm: true }));

    // Mapeamos driversEnrolled a objetos DriverApiCipia con driverID como key
    const historyEnrolled: { [driverID: string]: DriverApiCipia } = {};
    driversEnrolled.forEach(driverEnrolled => {
      historyEnrolled[driverEnrolled.key_number] = {
        deviceID: imei,
        driverID: driverEnrolled.key_number,
        driverProgrammingID: driverEnrolled.id,
        type: 'enrolar',
        status: 'success',
        savedConfirm: true
      };
    });

    // 2. Filtrar historial local anterior para eliminar entradas con status success y tipo enrolar
    const cleanHistory: { [driverID: string]: DriverApiCipia } = {};
    Object.entries(history).forEach(([driverID, req]) => {
      if (!(req.status === 'success' && req.type === 'enrolar' || req.savedConfirm)) {
        cleanHistory[driverID] = req;
      }
    });

    // 3. Combinar los objetos: historyEnrolled tiene prioridad sobre cleanHistory
    const newHistory = { ...historyEnrolled, ...cleanHistory };

    // 4. Convertir historial combinado en objetos DriverProgramming[]
    const enrolledHistory: DriverProgramming[] = this.driverService.driversProgramming
      .filter(driver =>
        driver.key_type === 'ICIPIA' &&
        driver.fecha_fin == null &&
        Object.values(newHistory).some(enrolled => enrolled.driverProgrammingID === driver.id)
      )
      .map(driver => {
        const status = Object.values(newHistory).find(h => h.driverProgrammingID === driver.id)?.status;
        return { ...driver, status };
      });

    allHistory[imei] = newHistory;
    this.enrollmentRequestHistory.next({ ...allHistory });
    console.log(allHistory, "update history");
    return enrolledHistory;
  }

  public getDriverUnRolledList(enrolledList: DriverProgramming[]): DriverProgramming[] {
    return this.driverService.driversProgramming.filter(driver =>
      driver.key_type === 'ICIPIA' &&
      driver.fecha_fin == null &&
      // Filtrar solo los que NO están en la lista de inscritos
      !enrolledList.some(enrolled => enrolled.id === driver.id)
    );
  }
  public getDriversEnrolledLists(
    driversEnrolledConfirm: DriverListIcipia[],
    imei: string
  ): {
    enrolled: DriverProgramming[],
    notEnrolled: DriverProgramming[]
  } {
    // Obtener la lista de conductores inscritos actualizada según el historial y confirmaciones del servidor
    const enrolledList = this.getDriverEnrolledHistoryList(driversEnrolledConfirm, imei);

    // Obtener los conductores no inscritos (los que no están en enrolledList)
    const notEnrolled = this.getDriverUnRolledList(enrolledList);

    // Obtener el historial completo para debug
    const history = this.enrollmentRequestHistory.getValue();
    console.log("enrollment history", history);

    return {
      enrolled: enrolledList,
      notEnrolled: notEnrolled
    };
  }
  public getDriverLists(history: { [driverID: string]: DriverApiCipia }): {
    enrolled: DriverProgramming[],
    notEnrolled: DriverProgramming[]
  } {

    const driverEnrolled: DriverProgramming[] = this.driverService.driversProgramming
      .filter(driver =>
        driver.key_type === 'ICIPIA' &&
        driver.fecha_fin == null &&
        history.hasOwnProperty(driver.key_number) // ahora verifica si existe la clave driverID en el objeto history
      )
      .map(driver => {
        const driverHist = history[driver.key_number];
        const status = driverHist?.status;
        const type = driverHist?.type;
        const savedConfirm = driverHist?.savedConfirm;
        const errorMessage = driverHist?.errorMessage;
        return { ...driver, status, type, savedConfirm, errorMessage};
      });

    const notEnrolled = this.getDriverUnRolledList(driverEnrolled);

    console.log("driver enrolled list", driverEnrolled, notEnrolled)

    return {
      enrolled: driverEnrolled,
      notEnrolled: notEnrolled
    };
  }

  public sendDriverEnrollmentRequest(driver: DriverApiCipia) {
    const imei = driver.deviceID;
    const history = this.enrollmentRequestHistory.getValue();

    // Aseguramos que history[imei] sea un objeto
    let driversHistory = history[imei] ?? {};

    // Verificar si ya existe una solicitud de enrolamiento activa (distinta de error)
    const alreadyExists = Object.values(driversHistory).some(
      d => d.driverID === driver.driverID && d.type === 'enrolar' && d.status !== 'error'
    );
    console.log("enrollment : enrolar", alreadyExists, driversHistory, driver);
    if (alreadyExists) return;

    // Limpiar errores antiguos de enrolamiento para este driver
    const filteredEntries = Object.entries(driversHistory).filter(
      ([, d]) => !(d.driverID === driver.driverID && d.type === 'enrolar' && d.status === 'error')
    );
    const filteredDriversHistory: { [key: string]: DriverApiCipia } = {};
    for (const [key, d] of filteredEntries) {
      filteredDriversHistory[key] = d;
    }
    driversHistory = filteredDriversHistory;

    // Buscar petición de desenrolar en espera
    const unenrollmentEntry = Object.entries(driversHistory).find(
      ([, d]) => d.driverID === driver.driverID && d.type === 'desenrolar' && d.status === 'waiting'
    );

    if (unenrollmentEntry) {
      const [key, d] = unenrollmentEntry;

      if (d.savedConfirm && d.previousEnrolledData) {
        // ✅ Restaurar el estado de enrolamiento anterior si estaba confirmado
        driversHistory[key] = {
          ...d.previousEnrolledData,
          status: 'success',
          type: 'enrolar',
          savedConfirm: true
        };
      } else {
        // ❌ Descartar si no hay confirmación previa
        delete driversHistory[key];
      }

      // Actualizar historial
      if (Object.keys(driversHistory).length === 0) {
        delete history[imei];
      } else {
        history[imei] = driversHistory;
      }

      this.enrollmentRequestHistory.next({ ...history });
      return;
    }

    // Nueva solicitud de enrolamiento
    const newRequest: DriverApiCipia = {
      ...driver,
      status: 'waiting',
      type: 'enrolar',
    };

    driversHistory[driver.driverID] = newRequest;
    history[imei] = driversHistory;
    this.enrollmentRequestHistory.next({ ...history });

    this.processNextInQueue(imei);
  }
  public sendDriverUnrollmentRequest(driver: DriverApiCipia): boolean {
    const imei = driver.deviceID;
    const history = this.enrollmentRequestHistory.getValue();
    const driversHistory = history[imei] ?? {};

    // 1. Verificar si ya existe una solicitud de desenrolar activa
    const alreadyExists = Object.values(driversHistory).some(
      d => d.driverID === driver.driverID &&
        d.type === 'desenrolar' &&
        (d.status === "loading" || d.status === "waiting")
    );
    console.log("enrollment : desenrolar", alreadyExists, driversHistory, driver);
    if (alreadyExists) return false;

    // 2. Eliminar errores previos de desenrolamiento
    for (const key in driversHistory) {
      const d = driversHistory[key];
      if (d.driverID === driver.driverID && d.type === 'desenrolar' && d.status === 'error') {
        delete driversHistory[key];
      }
    }

    // 3. Cancelar si hay solicitud de enrolar 'waiting'
    const waitingKey = Object.keys(driversHistory).find(key => {
      const d = driversHistory[key];
      return d.driverID === driver.driverID && d.type === 'enrolar' && d.status === 'waiting';
    });

    if (waitingKey) {
      delete driversHistory[waitingKey];

      if (Object.keys(driversHistory).length === 0) {
        delete history[imei];
      } else {
        history[imei] = driversHistory;
      }

      this.enrollmentRequestHistory.next({ ...history });
      return true; // No se requiere solicitud nueva de desenrolar
    }

    // 4. Si existe un enrolamiento confirmado (success), preparar desenrolar
    const successKey = Object.keys(driversHistory).find(key => {
      const d = driversHistory[key];
      return d.driverID === driver.driverID && d.type === 'enrolar' && d.status === 'success';
    });

    if (successKey) {
      const enrolment = driversHistory[successKey];

      const newUnenrollRequest: DriverApiCipia = {
        ...driver,
        status: 'waiting',
        type: 'desenrolar',
        savedConfirm: true,
        previousEnrolledData: enrolment, // ← Guardamos el estado anterior
      };

      delete driversHistory[successKey]; // Eliminamos el enrolamiento confirmado
      driversHistory[driver.driverID] = newUnenrollRequest;

      history[imei] = driversHistory;
      this.enrollmentRequestHistory.next({ ...history });
      this.processNextInQueue(imei);
      return true;
    }

    // 5. No hay enrolamiento registrado, solo agregamos desenrolamiento nuevo
    const newRequest: DriverApiCipia = {
      ...driver,
      status: 'waiting',
      type: 'desenrolar',
    };

    driversHistory[driver.driverID] = newRequest;
    history[imei] = driversHistory;
    this.enrollmentRequestHistory.next({ ...history });
    this.processNextInQueue(imei);

    return false;
  }

  public updateDriverEntry(
    imei: string,
    driverID: string,
    updateFn: (driver?: DriverApiCipia) => DriverApiCipia | null
  ) {
    const history = this.enrollmentRequestHistory.getValue();
    const currentDrivers = history[imei] ?? {};

    const updatedDriver = updateFn(currentDrivers[driverID]);
    if (updatedDriver === null) {
      delete currentDrivers[driverID];
    } else {
      currentDrivers[driverID] = updatedDriver;
    }

    const newHistory = { ...history };
    if (Object.keys(currentDrivers).length === 0) {
      delete newHistory[imei];
    } else {
      newHistory[imei] = { ...currentDrivers };
    }

    this.enrollmentRequestHistory.next(newHistory);
  }

  private processingIMEIs = new Set<string>();

  private processNextInQueue(imei: string): void {
    if (this.processingIMEIs.has(imei)) return;
    this.processingIMEIs.add(imei);

    const history = this.enrollmentRequestHistory.getValue();
    const drivers = history[imei] ?? {};

    // Verificar si hay algún driver en estado 'loading'
    if (Object.values(drivers).some(d => d.status === 'loading')) {
      this.processingIMEIs.delete(imei);
      return;
    }

    // Encontrar la primera petición con estado 'waiting'
    const waitingEntryKey = Object.keys(drivers).find(key => drivers[key].status === 'waiting');
    if (!waitingEntryKey) {
      this.processingIMEIs.delete(imei);
      return;
    }

    // Actualizar el driver con estado 'loading'
    this.updateDriverEntry(imei, waitingEntryKey, (d) => {
      if (!d) return null;
      return { ...d, status: 'loading' as const };
    });

    const finish = () => {
      this.processingIMEIs.delete(imei);
      setTimeout(() => this.processNextInQueue(imei), 1000);
    };

    const onSuccess = () => {
      this.updateDriverEntry(imei, waitingEntryKey, (d) => {
        if (!d) return null;
        if (d.type === 'enrolar') {
          return { ...d, status: 'success', savedConfirm: true };
        } else if (d.type === 'desenrolar') {
          return null; // eliminar
        } else {
          console.error('Tipo desconocido en onSuccess:', d);
          return { ...d, status: 'error' };
        }
      });
      finish();
    };

    const onError = (error : any) => {

      console.log("error enrollmente service")
      this.updateDriverEntry(imei, waitingEntryKey, (d) => {
        console.log("error enrollmente service", d)
        if (!d) return null;
        
        if (d.type === 'desenrolar' && d.savedConfirm) {
          console.log("error enrollmente service pasasss", d)
          console.warn(`⚠️ Desenrolamiento fallido, restaurando enrolamiento para driverID=${d.driverID}`);
          
          return {
            ...d,
            status: 'error',
            errorMessage : error.error.messages
          };
        }

        const errorMessage = error?.error?.messages ?? 'Surgió un problema desconocido';
        console.error(`❌ Error procesando ${d.type} para driverID=${d.driverID}, `, errorMessage);
        return { ...d, status: 'error', errorMessage : errorMessage};
      });
      finish();
    };

    const driverToProcess = this.enrollmentRequestHistory.getValue()[imei]?.[waitingEntryKey];
    if (!driverToProcess) {
      // Si el driver desapareció en medio, terminar
      finish();
      return;
    }

    if (driverToProcess.type === 'enrolar') {
      this.driverService.addDriverEnrolled(driverToProcess).subscribe(onSuccess, onError);
    } else if (driverToProcess.type === 'desenrolar') {
      console.log("enrolar aqui")
      this.driverService.deleteDriverEnrolled(driverToProcess).subscribe(onSuccess, onError);
    } else {
      this.updateDriverEntry(imei, waitingEntryKey, (d) =>
        d ? { ...d, status: 'error' } : null
      );
      console.error('Tipo desconocido:', driverToProcess);
      finish();
    }
  }


  public getVehicleConfig(vehicleUnit: any): VehicleEnrolledConfig {
    const vehicleType = vehicleUnit.unitType || "ALL";
    const config = this.specialVehicle[vehicleType] || this.specialVehicle["ALL"]
    console.log("driver enrolled vehicle", config)
    return config
}


  public getLimitFromVehicle(vehicleUnit : any) {

  }

  public existsEnrolledInHistory(imei : string){
    const history = this.enrollmentRequestHistory.getValue();
    const drivers = history[imei] ?? {};
    const enrolledDrivers = Object.values(drivers).filter(d => d.type === 'enrolar');
    return enrolledDrivers.length > 0
  }
  

  public isVehicleOneEnrolled(vehicleUnit : any) : boolean {
    const vehicleType = vehicleUnit.unitType || "";
    const config = this.specialVehicle[vehicleType];
    if (!config) return false
    return config.onlyOneEnrolled
  }


  // reglas y permisos
  public hasEnrolledVehicle(vehicleUnit : any, imei : string): boolean {

    const vehicleType = vehicleUnit.unitType || "";
    const config = this.specialVehicle[vehicleType];
    const history = this.enrollmentRequestHistory.getValue();
    const drivers = history[imei] ?? {};
    if (!config) return true;
    const enrolledDrivers = Object.values(drivers).filter(d => d.type === 'enrolar');
    const waitingDrivers = Object.values(drivers).filter(d => d.status === 'waiting');
    if (config.onlyOneEnrolled && enrolledDrivers.length >= 1) {
      console.warn(`🚫 Solo se permite un conductor enrolado para ${vehicleType}`);
      return false;
    }
    if (config.limit && enrolledDrivers.length >= config.limit) {
      console.warn(`🚫 Límite de ${config.limit} enrolamientos alcanzado para ${vehicleType}`);
      return false;
    }
    return true;
  }


}
